export const TEST_ACTION_HANDLER = 'TEST_ACTION_HANDLER';
export const GET_ME_DATA_SUCCESS = 'GET_ME_DATA_SUCCESS';
export const GET_ME_DATA_ERROR = 'GET_ME_DATA_ERROR';
